<template>
    <div style="width:100%;height:100%">
        <buttonlist
                ref="SetBtn"
                @help="help"
        ></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white">
                <el-button type="primary" size="mini" @click="showitems">{{$t('getapi[4412]')}}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{$t('getapi[437]')}}</el-button>
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[436]')}}</el-button>
                    </el-upload>
                    
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{$t('getapi[506]')}}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select></el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{$t('getapi[507]')}}</el-button>
                    <!-- <el-button type="primary" size="mini">关闭</el-button> -->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <el-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    @cell-dblclick="editInfo"
                    tab-click="selectInfo(0)"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="DataStatus" :label="$t('getapi[504]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_status" :label="$t('getapi[114]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
                <el-table-column :class-name="editPlan == 'page_no'?'check':''"
                                 prop="page_no" :label="$t('getapi[127]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.page_no"
                                  v-if="editPlan == 'page_no'"></el-input>
                        <span v-if="editPlan != 'page_no'">{{scope.row.page_no}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'weight' ? 'check' : ''" prop="weight" :label="$t('getapi[138]')"  >
                    <template scope="scope" >
                        <el-input class-name="check" size="small" v-model="scope.row.weight"
                                  v-if="editPlan == 'weight'" type="number" autocomplete="off" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'weight'">{{ scope.row.weight|tofixed4 }}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'msds_flag'?'check':''"
                                 prop="msds_flag" :label="$t('getapi[13322]')">
                    <template scope="scope">
                        <!-- <el-checkbox   :disabled="editPlan != 'msds_flag'" v-model="scope.row.msds_flag" :true-label=1 false-label=1></el-checkbox> -->
                        <el-select v-if="editPlan == 'msds_flag'" v-model="scope.row.msds_flag">
                            <el-option :label="$t('getapi[561]')" :value="1" :key="1"></el-option>
                            <el-option :label="$t('getapi[866]')" :value="0" :key="0"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'msds_flag'">{{scope.row.msds_flag}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Eng/Parts/PartBaseInfoGetPart'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'partbaseinfosetting',
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 178, // 主表高度
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [{
                    value: '0',
                    label: this.$t('getapi[852]')//'未选择'
                }, {
                    value: 'page_no',
                    label: this.$t('getapi[127]')//'页码'
                },
                {
                    value: 'weight',
                    label: this.$t('getapi[138]')//'重量'
                },
                {
                    value: 'msds_flag',
                    label: this.$t('getapi[13322]')//'安全级符号标识'
                }],
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Eng/Parts/PartBaseInfoImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6012]"),this.$t("getapi[18]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            getitembom(data) {
                let that = this
                if(data.length > 0){                 
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            part_status: data[i].part_status,
                            part_name: data[i].part_name,    
                            page_no: data[i].page_no,       
                            weight: data[i].weight,                              
                            item_code: data[i].item_code, 
                            msds_flag: data[i].msds_flag,                               
                            DataStatus: data[i].DataStatus,
                            exclusively_id: data[i].exclusively_id
                        }]
                    }
                }
            },
            handleSelectionChange(val) {
                let that = this;
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i].exclusively_id);
                }
            },
            remove() {
                let that = this
                let arr = that.dataSet.filter(item => {
                    return that.dataChecked.every(item2 => {
                        return item.exclusively_id != item2
                    })
                })
                that.dataSet = arr;
                that.fileList = [];
            },
            handleChange(file, fileList) {
                let that = this;
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                let response = res.Success;

                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent
                    data = data.filter(item => {
                        return that.dataSet.every(item2 => {
                            return item.exclusively_id != item2.exclusively_id;
                        });
                    });
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            part_status: data[i].part_status,
                            part_name: data[i].part_name,
                            page_no: data[i].page_no,
                            weight: data[i].weight,       
                            msds_flag: data[i].msds_flag,                         
                            item_code: data[i].item_code,  
                            DataStatus: data[i].DataStatus,
                            exclusively_id: data[i].exclusively_id
                        }]
                    }
                    that.dataSet = res.DataContent
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(this.$t('getapi[8585]')+':' + err);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: "",
                    name: that.editPlan
                };
                that.$http.urlpost('/Eng/Parts/PartBaseInfoUpdate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
</style>
